"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommunityResult = isCommunityResult;
exports.isCommunityResultEvent = isCommunityResultEvent;
exports.isFederatedResult = isFederatedResult;
exports.isFreshdeskResult = isFreshdeskResult;
exports.isMultiIndexResult = isMultiIndexResult;
exports.isSalesforceResult = isSalesforceResult;
exports.isSkilljarResult = isSkilljarResult;
exports.isZendeskResult = isZendeskResult;

/**
 * Type guard to check if a search result is from the community (internal content).
 * @param el - Search result to check
 * @returns true if the result is from community or knowledge base
 */
function isCommunityResult(el) {
  return el.source === 'community' || el.source === 'knowledge_base';
}
/**
 * Type guard to check if a community result is an event.
 * @param el - Community result to check
 * @returns true if the result is an event
 */


function isCommunityResultEvent(el) {
  return el.content_type === 'event';
}
/**
 * Type guard to check if a search result is from Zendesk.
 * @param el - Search result to check
 * @returns true if the result is from Zendesk
 */


function isZendeskResult(el) {
  return el.source === 'zendesk';
}
/**
 * Type guard to check if a search result is from Salesforce.
 * @param el - Search result to check
 * @returns true if the result is from Salesforce
 */


function isSalesforceResult(el) {
  return el.source === 'salesforce';
}
/**
 * Type guard to check if a search result is from Skilljar.
 * @param el - Search result to check
 * @returns true if the result is from Skilljar
 */


function isSkilljarResult(el) {
  return el.source === 'skilljar';
}
/**
 * Type guard to check if a search result is from Freshdesk.
 * @param el - Search result to check
 * @returns true if the result is from Freshdesk
 */


function isFreshdeskResult(el) {
  return el.source === 'freshdesk';
}
/**
 * Type guard to check if a search result is federated (external).
 * @param el - Search result to check
 * @returns true if the result is federated
 */


function isFederatedResult(el) {
  return !isCommunityResult(el) && !isZendeskResult(el) && !isSalesforceResult(el) && !isSkilljarResult(el) && !isFreshdeskResult(el);
}
/**
 * Type guard to check if search results are multi-index results.
 * @param results - Search results to check
 * @returns true if results are multi-index
 */


function isMultiIndexResult(results) {
  return results !== null && !('index' in results);
}